import { Box, Typography } from "@mui/material";
import React from "react";

const fmt = d => new Date(d).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

/**
 * Resumo somente leitura das tarefas (Registrar Tarefa / Registrar Período de
 * Tarefa) já registradas no atendimento em curso — usado nos modais de
 * fechamento e de devolver para fila, antes dos campos de tempo de trabalho
 * do GLPI (que passam a ser calculados a partir dessas entries).
 */
const TaskEntriesSummary = ({ entries }) => {
	if (!entries || entries.length === 0) return null;

	const totalMins = Math.round(entries.reduce((acc, e) => acc + (e.durationSeconds || 0), 0) / 60);

	return (
		<Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, p: 1.5 }}>
			<Typography variant="subtitle2" sx={{ mb: 1 }}>
				Tarefas registradas neste atendimento
			</Typography>
			{entries.map(entry => {
				const mins = Math.round((entry.durationSeconds || 0) / 60);
				return (
					<Box key={entry.id} sx={{ mb: 1, "&:last-child": { mb: 0 } }}>
						<Typography variant="body2" sx={{ fontWeight: 500 }}>
							{entry.description}
						</Typography>
						<Typography variant="caption" color="text.secondary">
							{fmt(entry.startAt)} → {fmt(entry.endAt)} · {Math.floor(mins / 60)}h{String(mins % 60).padStart(2, "0")}min
							{entry.userName ? ` · ${entry.userName}` : ""}
						</Typography>
					</Box>
				);
			})}
			<Typography variant="caption" sx={{ display: "block", mt: 1, fontWeight: 600 }}>
				Total: {Math.floor(totalMins / 60)}h{String(totalMins % 60).padStart(2, "0")}min
			</Typography>
		</Box>
	);
};

export default TaskEntriesSummary;
